import { isEmpty } from "lodash";
import { serviceMaker, methods, api } from "../index.js";
import { queryString } from "../../plugins/index.js";
require("dotenv").config();

export const getClients = (queryParams) =>
  serviceMaker(`/clients?${queryString(queryParams)}`, methods.GET, api.NGB);
export const createClients = (data) => {
  const customHeaders = {
    "Content-Type": "application/json",
  };
  return serviceMaker(`/clients`, methods.POST, api.NGB, data, customHeaders);
};

export const paymentTypeInfo = (payload) => {
  const customHeaders = {
    "Content-Type": "application/json",
  };
  return serviceMaker(
    `/clients/${payload.clientId}/carddetails`,
    methods.POST,
    api.NGB,
    payload.data,
    customHeaders
  );
};
export const getPaymentInfo = (id) =>
  serviceMaker(`/clients/${id}/carddetails`, methods.GET, api.NGB);

export const getClientById = (id) =>
  serviceMaker(
    `/clients/getclient360/v2?key=id&value=${id}`,
    methods.GET,
    api.NGB
  );

export const getClientBillId = (id) =>
  serviceMaker(`/clientbillprofile/bills/${id}`, methods.GET, api.NGB);

export const getFinancialTransaction = (id) =>
  serviceMaker(`/financialTransactions/${id}/invoice`, methods.GET, api.NGB);

export const getClientEditBillId = (id) =>
  serviceMaker(
    `/clients/billprofile/${id}?template=true`,
    methods.GET,
    api.NGB
  );
export const fetchQuoteAndLeadId = (id) =>
  serviceMaker(`/quotes/quoteNumber/${id}`, methods.GET, api.NGB);

export const putClientSave = (id, data) =>
  serviceMaker(`/clientbillprofile/${id}`, methods.PUT, api.NGB, data);

// Customer Activation
export const getNetworkDetails = (serviceId) => {
  return serviceMaker(
    `/clientservice/servicedetails/${serviceId}?paramCategory=S`,
    methods.GET,
    api.NGB
  );
};
export const getplanDetails = (id) =>
  serviceMaker(
    `/orders/template?planId=0&salesCatalogeId=${id}`,
    methods.GET,
    api.NGB
  );
export const getSalesPlanCategory = (params) => {
  if (!isEmpty(params))
    return serviceMaker(
      `/usercataloge/salesPlanCategory?${queryString(params)}`,
      methods.GET,
      api.NGB
    );
  // return serviceMaker(`/usercataloge/salesPlanCategory`, methods.GET, api.NGB);
};
export const getLoc = (keyword) =>
  serviceMaker(`/clients/searching/1/?query=${keyword}`, methods.GET, api.NGB);
export const getSerialNo = (keyword) =>
  serviceMaker(`/itemdetails/0/3?query=${keyword}`, methods.GET, api.NGB);
export const getPairSerialNo = (serialNo) => {
  // serviceMaker(`/itemdetails/serialnum?officeId=3&query=${serialNo}`, methods.GET, api.NGB);
  serviceMaker(`/itemdetails/pairableitems/${serialNo}`, methods.GET, api.NGB);
};
export const addClientActivation = (clientId, data) =>
  serviceMaker(
    `/activationprocess/customeractivation`,
    methods.POST,
    api.NGB,
    data
  );
//{"clientId":"11","serialNo":"SCS0003","clientServiceStatus":"ACIVE","isStraight":true}
export const deallocateClientDevice = (id, data) =>
  serviceMaker(`/itemdetails/deallocate/${id}`, methods.PUT, api.NGB, data);

export const getClientsTemplate = () =>
  serviceMaker(`/clients/template`, methods.GET, api.NGB);
export const getListTemplate = (id) =>
  serviceMaker(`/payments/template?clientId=${id}`, methods.GET, api.NGB);
export const getOptionsTemplate = () =>
  serviceMaker(`/clients/searching/1/?query=`, methods.GET, api.NGB);

export const getClientServiceTemplate = () =>
  serviceMaker(`/clientservice/template`, methods.GET, api.NGB);

export const getClientNotes = (clientId) =>
  serviceMaker(`/clients/${clientId}/notes`, methods.GET, api.NGB);
//{"note":"new test note for client id 11"}
export const addClientNotes = (clientId, note) =>
  serviceMaker(`/clients/${clientId}/notes`, methods.POST, api.NGB, note);

export const getIdentifierTemplate = (clientId) =>
  serviceMaker(
    `clients/${clientId}/identifiers/template`,
    methods.GET,
    api.NGB
  );
export const getClientIdentifiers = (clientId) =>
  serviceMaker(`/clients/${clientId}/identifiers`, methods.GET, api.NGB);

//{documentTypeId: 4, documentKey: "14563287", description: "other type ID"}
export const addClientIdentifiers = (clientId, data) =>
  serviceMaker(`/clients/${clientId}/identifiers`, methods.POST, api.NGB, data);
export const deleteClientIdentifiers = (clientId, identifierId) =>
  serviceMaker(
    `/clients/${clientId}/identifiers/${identifierId}`,
    methods.DELETE,
    api.NGB
  );
//{name: Adhar, file:}
export const uploadIdentifierDocument = (identifierId, data) =>
  serviceMaker(
    `/client_identifiers/${identifierId}/documents`,
    methods.POST,
    api.NGB,
    data
  );
export const getIdentifierDocument = (identifierId) =>
  serviceMaker(
    `/client_identifiers/${identifierId}/documents`,
    methods.GET,
    api.NGB
  );

//{"nationality":167,"jobTitle":"Some","preferredLang":169,"remarks":"Some Remark","idType":1,"idNumber":"1234567890","ageGroup":173,"utsCustomerId":"1478956","financeId":"4789224","preferredCommunication":171,"dateFormat":"dd MMMM yyyy","activationDate":"16 December 2019","locale":"en","dateOfBirth":"03 December 1995"}
export const additionalInfoTemplate = (clientId) =>
  serviceMaker(`/clients/additionalinfo/${clientId}`, methods.GET, api.NGB);
export const getAdditionalInfo = () =>
  serviceMaker(`/clients/additionalinfo/template`, methods.GET, api.NGB);
export const createAdditionalInfoTemplate = (clientId, data) =>
  serviceMaker(
    `/clients/additionalinfo/${clientId}`,
    methods.POST,
    api.NGB,
    data
  );

//{name: Adhar
// description: dfdsfsdfsdfsd
// file: (binary)}
export const uploadClientDocument = (clientId, data) =>
  serviceMaker(
    `/clientticket/${clientId}/documents`,
    methods.POST,
    api.NGB,
    data
  );
export const getAllClientDocuments = (clientId) =>
  serviceMaker(`/clientticket/${clientId}/documents`, methods.GET, api.NGB);
export const deleteClientDocument = (clientId, documentId) =>
  serviceMaker(
    `/clients/${clientId}/documents/${documentId}`,
    methods.DELETE,
    api.NGB
  );

export const updateTaxExemption = (payload) =>
  serviceMaker(
    `/taxexemption/${payload.id}`,
    methods.PUT,
    api.NGB,
    payload.data
  );
export const getdownloadDocumentProfile = (clientId, docId) =>
  serviceMaker(
    `/clientticket/${clientId}/documents/attachment/${docId}`,
    methods.GET,
    api.NGB
  );

export const getClientBillProfile = (clientId) =>
  serviceMaker(`/clientbillprofile/bills/${clientId}`, methods.GET, api.NGB);

export const getClientCardDetails = (clientId) =>
  serviceMaker(`/clients/${clientId}/carddetails`, methods.GET, api.NGB);
//{"type":"CreditCard","cardType":"MASTERCARD","name":"Some Name","cvvNumber":"U2FsdGVkX19vgeHStskZeD1H0NiPw4h4ORu0ISvXP1g=","cardNumber":"U2FsdGVkX1/k4zZ7HG3anDtnA7BDpZnm7ZR17+MV+18=","cardExpiryDate":"U2FsdGVkX1+GADz9QoFBsaloAweA7KIETFDopwBeSBA="}
export const addClientCardDetail = (clientId, data) =>
  serviceMaker(`/clients/${clientId}/carddetails`, methods.POST, api.NGB, data);

export const getClientTickets = (clientId) =>
  serviceMaker(`/tickets/${clientId}`, methods.GET, api.NGB);
export const getClientTicketTask = (clientId) =>
  serviceMaker(`/tickets/subtask/${clientId}`, methods.GET, api.NGB);
export const cancelSubTaskTicket = (taskId, data) =>
  serviceMaker(`/tickets/subtask/update/${taskId}`, methods.PUT, api.NGB, data);
export const getTicketTemplate = () =>
  serviceMaker(`/tickets/template`, methods.GET, api.NGB);
export const getTicketSubCategory = (categoryId) =>
  serviceMaker(
    `/subcategory/byCategory?category=${categoryId}`,
    methods.GET,
    api.NGB
  );
export const getTicketTeamUsers = (teamUserId) =>
  serviceMaker(
    `/tickets/teamusers?teamusers=${teamUserId}`,
    methods.GET,
    api.NGB
  );
// {"assignedTo":1,"priority":"LOW","sourceOfTicket":"Phone","problemCode":249,"subCategory":"selfcare1","teamCode":39,"description":"xfmgngklfnhlglkmgkjhjgm,","locale":"en","dateFormat":"dd MMMM yyyy","ticketDate":"17 December 2019","ticketURL":"https://smartway.trigital.in/app/#/viewTicket/10","ticketTime":" 10:21:15 AM"}
export const createTicket = (clientId) => (clientId) =>
  serviceMaker(`/tickets/ticketing/${clientId}`, methods.POST, api.NGB, data);

export const getEventOrderByClient = (clientId) =>
  serviceMaker(`/eventorder?clientId=${clientId}`, methods.GET, api.NGB);
export const clientEventOrderTemplate = (clientId) =>
  serviceMaker(`/eventorder/${clientId}`, methods.GET, api.NGB);
export const createEventOrder = (data) =>
  serviceMaker(`/eventorder`, methods.POST, api.NGB, data);

export const getChildsByClientId = (clientId) =>
  serviceMaker(`/parentclient/child/${clientId}`, methods.GET, api.NGB);
export const getMessagesLogByCustomer = (clientId) =>
  serviceMaker(`/messages/clientmessageData/${clientId}`, methods.GET, api.NGB);

export const getTransactionDetails = (params, clientId) => {
  if (!isEmpty(params))
    return serviceMaker(
      `/financialTransactions/${clientId}/type?type=${params.type}&limit=14&offset=0`,
      methods.GET,
      api.NGB
    );
  return serviceMaker(
    `/financialTransactions/${clientId}?payments=id`,
    methods.GET,
    api.NGB
  );
};
export const getClientBillMaster = (clientId) =>
  serviceMaker(`/billmaster/${clientId}`, methods.GET, api.NGB);
export const sendBillMasterEmail = (billMasterId, data) =>
  serviceMaker(`/billmaster/email/${billMasterId}`, methods.PUT, api.NGB, data);
export const getClientProvisioningDetail = (serviceId) =>
  serviceMaker(`/provisioning/template/${serviceId}`, methods.GET, api.NGB);
export const getOneTimeSalesTemplate = () =>
  serviceMaker("onetimesales/template", methods.GET, api.NGB);
// export const getSalesPlanCategory = (params) =>  {
//   if (!isEmpty(params))
//     return serviceMaker(`/usercataloge/salesPlanCategory?${queryString(params)}`, methods.GET, api.NGB);
//   return serviceMaker(`/usercataloge/salesPlanCategory`, methods.GET, api.NGB);
// }
export const getsalescataloges = (params) => {
  if (!isEmpty(params))
    return serviceMaker(
      `/salescataloge/salescataloges?${queryString(params)}`,
      methods.GET,
      api.NGB
    );
  return serviceMaker(`/salescataloge/salescataloges`, methods.GET, api.NGB);
};
export const getClientServiceDetails = (params) => {
  if (!isEmpty(params))
    return serviceMaker(
      `/clientservice/servicedetails?${queryString(params)}`,
      methods.GET,
      api.NGB
    );
  return serviceMaker(`/clientservice/servicedetails`, methods.GET, api.NGB);
};
export const getNetworkNodeDetails = (serviceId, clientId) => {
  return serviceMaker(
    `/clientservice/servicedetails/${serviceId}?clientId=${clientId}&paramCategory=S`,
    methods.GET,
    api.NGB
  );
};
export const getOneTimeSales = (serialno) =>
  serviceMaker(`/onetimesales/paired/${serialno}`, methods.GET, api.NGB);
export const getOrders = (id) =>
  serviceMaker(`/orders/${id}/orderprice`, methods.GET, api.NGB);
export const addOrderPrice = (orderId, price) =>
  serviceMaker(`/orders/${orderId}/orderprice`, methods.PUT, api.NGB, price);
export const orderPromotion = () =>
  serviceMaker(`/promotioncode`, methods.GET, api.NGB);
// export const orderDisconnect = () =>
//   serviceMaker(`/orders/disconnect`, methods.GET, api.NGB);
export const getPlan = (PlanListid, clientId) =>
  serviceMaker(
    `/salescataloge/salescataloges/${PlanListid}?clientId=${clientId}&clientServiceId=0&planId=0`,
    methods.GET,
    api.NGB
  );
export const getBasePlan = () =>
  serviceMaker(
    `/usercataloge/salesPlanCategory?category=Base+Pack`,
    methods.GET,
    api.NGB
  );
export const getAdjustmentsTemplate = () =>
  serviceMaker("/adjustments/template", methods.GET, api.NGB);
export const createAdjustments = (id, data) =>
  serviceMaker(`/adjustments/${id}`, methods.POST, api.NGB, data);
export const createDocumentCsvPdf = (id, format, fromDate, toDate) =>
  serviceMaker(
    `/financialTransactions/download/${id}?downloadType=${format}&fromDate=${fromDate}&toDate=${toDate}&tenantIdentifier=default`,
    methods.GET,
    api.NGB
  );
export const cancelPayment = (id, data) =>
  serviceMaker(`/payments/cancelpayment/${id}`, methods.PUT, api.NGB, data);
export const getBillDetails = (id) =>
  serviceMaker(`/billmaster/${id}/billdetails`, methods.GET, api.NGB);

export const itemDetailsByQuery = (officeId, data) =>
  serviceMaker(
    `/itemdetails/0/${officeId}?query=${data}`,
    methods.GET,
    api.NGB,
    data
  );
export const getItemDetails = (officeId, itemId) =>
  serviceMaker(
    `/itemdetails/serialnum?officeId=${officeId}&query=${itemId}`,
    methods.GET,
    api.NGB
  );
export const getSaleTemplate = () =>
  serviceMaker(`/onetimesales/template`, methods.GET, api.NGB);
export const getContractDetails = (id) =>
  serviceMaker(`/orders/${id}/template?template=true`, methods.GET, api.NGB);
export const getPlanData = (country, state) =>
  serviceMaker(
    `/orders/template?country=${country}&planId=0&state=${state}`,
    methods.GET,
    api.NGB
  );
export const simpleActivationPost = (data) =>
  serviceMaker(
    `/activationprocess/simpleactivation/v2`,
    methods.POST,
    api.NGB,
    data
  );
export const getPairedItemDetails = (officeId, data) =>
  serviceMaker(
    `/itemdetails/pairableitems/${officeId}?query=${data}`,
    methods.GET
  );

export const searchCustomer = (type, val) =>
  serviceMaker(
    `/clients/search/${type}?columnValue=${val}`,
    methods.GET,
    api.NGB
  );
export const getSaleTemplateById = (clientId) =>
  serviceMaker(
    `/onetimesales/template?clientId=${clientId}`,
    methods.GET,
    api.NGB
  );
export const addDeviceApi = (id, data) =>
  serviceMaker(
    `/onetimesales/${id}?devicesaleTpye=NEWSALE`,
    methods.POST,
    api.NGB,
    data
  );
export const getCommandTemplateById = (clientId) =>
  serviceMaker(
    `/provisioning?clientServiceId=${clientId}`,
    methods.GET,
    api.NGB
  );
// export const getPriorityMass = (id) =>
//   serviceMaker(`/commandparams/${id}`, methods.GET, api.NGB);
export const getPlanPacks = () =>
  serviceMaker(
    `/usercataloge/salesPlanCategory?category=all`,
    methods.GET,
    api.NGB
  );
export const getCataloguePlans = (id, clientId, serviceId) =>
  serviceMaker(
    `/salescataloge/salescataloges/${id}?clientId=${clientId}&clientServiceId=${serviceId}&planId=0`,
    methods.GET,
    api.NGB
  );
export const addPlanCatalogue = (id, data) =>
  serviceMaker(`/multipleorders/${id}`, methods.POST, api.NGB, data);
export const getClientServiceDetailsData = (payload) =>
  serviceMaker(
    `/clientservice/details/${payload.clientId}/${payload.serviceId}`,
    methods.GET,
    api.NGB
  );
export const getProvisioningList = (id) =>
  serviceMaker(`/provisioning/template/${id}`, methods.GET, api.NGB);
export const getCancelPlanList = (clientId, serviceId) =>
  serviceMaker(
    `/orders/${clientId}/orders?clientServiceId=${serviceId}`,
    methods.GET,
    api.NGB
  );
export const disconnectPlanList = () =>
  serviceMaker(`/orders/disconnect`, methods.GET, api.NGB);
export const cancelPlanPost = (id, data) =>
  serviceMaker(`/multipleorders/cancel/${id}`, methods.PUT, api.NGB, data);
export const suspendPlan = (id, data) =>
  serviceMaker(`/clientservice/suspend/${id}`, methods.PUT, api.NGB, data);
export const activatePlan = (id, data) =>
  serviceMaker(`/clientservice/reactive/${id}`, methods.PUT, api.NGB, data);
export const getChangePlansByPlan = (clientId, serviceId, planId, salesId) =>
  serviceMaker(
    `/orders/template?clientId=${clientId}&clientServiceId=${serviceId}&planId=${planId}&salesCatalogeId=${salesId}`,
    methods.GET,
    api.NGB
  );
export const changePlan = (id, data) =>
  serviceMaker(`/orders/changePlan/${id}`, methods.PUT, api.NGB, data);
export const serviceActivation = (id, data) =>
  serviceMaker(
    `/activationprocess/simpleactivation/${id}`,
    methods.POST,
    api.NGB,
    data
  );
export const serviceWDActivation = (id, data) =>
  serviceMaker(
    `/activationprocess/serviceactivationwod/${id}`,
    methods.POST,
    api.NGB,
    data
  );
export const userByTeam = (id) =>
  serviceMaker(`/tickets/teamusers?teamusers=${id}`, methods.GET, api.NGB);
export const createCustomerTicket = (id, data) =>
  serviceMaker(
    `/tickets/createCustomerTicket/V2/${id}`,
    methods.POST,
    api.NGB,
    data
  );
export const createCustomerTicketTask = (clientId, data) =>
  serviceMaker(
    `/tickets/subtask/create/${clientId}`,
    methods.POST,
    api.NGB,
    data
  );
export const getTicketDetailsById = (ticketId) =>
  serviceMaker(`/tickets/V2/${ticketId}`, methods.GET, api.NGB);
export const uploadTicketDocument = (id, data) =>
  serviceMaker(`/customerticket/${id}/documents`, methods.POST, api.NGB, data);
export const getTicketDocument = (id) =>
  serviceMaker(`/customerticket/${id}/documents`, methods.GET, api.NGB);
export const getUploadedDocumentData = (ticketId, docId, showImages) =>
  serviceMaker(
    `customerticket/${ticketId}/documents/${docId}/attachment?showImages=${showImages}`,
    methods.GET,
    api.NGB
  );
export const updateSubTicket = (id, data) =>
  serviceMaker(
    `tickets/subtask/updatedetails/${id}`,
    methods.PUT,
    api.NGB,
    data
  );
export const reassignTicket = (id, data) =>
  serviceMaker(`/tickets/reassign/${id}`, methods.PUT, api.NGB, data);
export const getSlcData = (id) =>
  serviceMaker(`/messages/kafkaConsumerData/${id}`, methods.GET, api.NGB);
export const swapTemplate = () =>
  serviceMaker(`/itemdetails/swap/template`, methods.GET, api.NGB);
export const itemDetailsByQuery2 = (item, officeId, data) =>
  serviceMaker(
    `/itemdetails/${item}/${officeId}?query=${data}`,
    methods.GET,
    api.NGB,
    data
  );
export const swapDevice = (data) =>
  serviceMaker(`/itemdetails/swapdevice`, methods.PUT, api.NGB, data);
export const serviceTerminate = (id, data) =>
  serviceMaker(`/clientservice/terminate/${id}`, methods.PUT, api.NGB, data);
export const makePayment = (id, data) =>
  serviceMaker(`/payments/${id}`, methods.POST, api.NGB, data);
export const getInoviceList = (id) =>
  serviceMaker(`/invoice/${id}`, methods.GET, api.NGB);
export const creditDistribution = (id, data) =>
  serviceMaker(`/creditdistributions/${id}`, methods.POST, api.NGB, data);
export const downloadReciept = (mode, clientId, transactionId) =>
  serviceMaker(
    `/billmaster/${mode}/${clientId}/${transactionId}?email=false&tenantIdentifier=default`,
    methods.GET,
    api.NGB
  );
export const makeStatement = (id, data) =>
  serviceMaker(`/billmaster/${id}`, methods.POST, api.NGB, data);
export const profilePicture = (id, data) =>
  serviceMaker(`/clients/${id}/images`, methods.POST, api.NGB, data);
export const editProfilePicture = (id, data) =>
  serviceMaker(`/clients/${id}/images`, methods.PUT, api.NGB, data);
export const getProfilePic = (id) =>
  serviceMaker(`/clients/${id}/images`, methods.GET, api.NGB);
export const getDocumentUploadPic = (id, docId) =>
  serviceMaker(
    `/clientticket/${id}/documents/${docId}/view`,
    methods.GET,
    api.NGB
  );
export const getEditTicketById = (clientId, id) =>
  serviceMaker(`/tickets/${clientId}/update/${id}`, methods.GET, api.NGB);
export const reopenCustomerTicket = (ticketId, data) =>
  serviceMaker(
    `/tickets/reopen/customer/${ticketId}`,
    methods.PUT,
    api.NGB,
    data
  );
export const reopenOfficeEntityTicket = (ticketId, data) =>
  serviceMaker(
    `/tickets/reopen/office/${ticketId}`,
    methods.PUT,
    api.NGB,
    data
  );
export const ticketDocument = (id, data) =>
  serviceMaker(`/clientTicket/${id}/documents`, methods.POST, api.NGB, data);
export const ticketUpdate = (ticketId, data) =>
  serviceMaker(
    `/tickets/updateCustomerTicket/V2/${ticketId}`,
    methods.PUT,
    api.NGB,
    data
  );
export const cancelTicket = (ticketId, data) =>
  serviceMaker(
    `/tickets/closeCustomerTicket/V2/${ticketId}`,
    methods.PUT,
    api.NGB,
    data
  );
export const getTicketById = (id) =>
  serviceMaker(`/tickets/ticketing/${id}`, methods.GET, api.NGB);
export const getViewTicketById = (id) =>
  serviceMaker(`/tickets/V2/${id}`, methods.GET, api.NGB);
export const orderChargingPost = (payload) =>
  serviceMaker(
    `/chargingorder/${payload.id}`,
    methods.POST,
    api.NGB,
    payload.data
  );
export const depositTemplate = (id) =>
  serviceMaker(`/deposit/${id}`, methods.GET, api.NGB);
export const postDepositTemplate = (data) =>
  serviceMaker(`/deposit`, methods.POST, api.NGB, data);
export const postrecieverTemplate = (data) =>
  serviceMaker(`/clientBalance/transfer`, methods.POST, api.NGB, data);
export const redeemption = (data) =>
  serviceMaker(`/redemption`, methods.POST, api.NGB, data);
export const getSalesTemplate = (id) =>
  serviceMaker(`/orders/template?salesCatalogeId=${id}`, methods.GET, api.NGB);
export const getActivityLog = (id, fromDate, toDate) =>
  serviceMaker(
    `/transactionhistory/${id}?fromDate=${fromDate}&offset=0&toDate=${toDate}`,
    methods.GET,
    api.NGB
  );
export const getExternalActivityLog = (id, fromDate, toDate) =>
  serviceMaker(
    `/transactionhistory/externalTrackerAPI/${id}?fromDate=${fromDate}&toDate=${toDate}`,
    methods.GET,
    api.NGB
  );
export const rechargeCdrNotificationDataApi = ({
  mssisdn,
  fromDate,
  toDate,
  dataId,
}) =>
  serviceMaker(
    `/transactionhistory/externalTrackerAPI/${mssisdn}?fromDate=${fromDate}&toDate=${toDate}&infoType=${dataId}`,
    methods.GET,
    api.NGB
  );
export const financialTransactionById = (id) =>
  serviceMaker(`/financialTransactions/${id}/invoice`, methods.GET, api.NGB);
export const updateCustomerInfo = (id, data) =>
  serviceMaker(`/clients/${id}`, methods.PUT, api.NGB, data);
export const updateCustomerAddress = (id, data) =>
  serviceMaker(`/address/rec/${id}`, methods.PUT, api.NGB, data);
export const getAddressByCustomer = (id) =>
  serviceMaker(`/address/addressdetails/${id}`, methods.GET, api.NGB);
export const orderDisconnects = () =>
  serviceMaker(`/orders/disconnect`, methods.GET, api.NGB);
export const renewalPlan = (id, data) =>
  serviceMaker(`/orders/renewal/${id}`, methods.POST, api.NGB, data);
export const getPlanDetails = (id) =>
  serviceMaker(
    `/orders/renewalorder?orderId=${id}&planType=prepaid`,
    methods.GET,
    api.NGB
  );
export const getDiscount = (id) =>
  serviceMaker(`/onetimesales/clientCategory/${id}`, methods.GET, api.NGB);

export const getUsageData = (id) =>
  serviceMaker(`/financialTransactions/billItemId/${id}`, methods.GET, api.NGB);

export const getPriceData = (id) =>
  serviceMaker(`/rateplan/getRatesByorderPriceId/${id}`, methods.GET, api.NGB);

export const getChargeData = (id) =>
  serviceMaker(`/financialTransactions/charges/${id}`, methods.GET, api.NGB);
export const applyPromoApi = (id, data) =>
  serviceMaker(`/orders/applypromo/${id}`, methods.PUT, api.NGB, data);
export const getFiscalYears = () =>
  serviceMaker(`/codes/108/codevalues`, methods.GET, api.NGB);
export const getFiscalQuarters = () =>
  serviceMaker(`/codes/109/codevalues`, methods.GET, api.NGB);
export const customerFullSearch = (data) =>
  serviceMaker(
    `/clients/search/fullsearch?columnValue=${data}`,
    methods.GET,
    api.NGB
  );
export const addRefund = (id, data) =>
  serviceMaker(`/refund/${id}`, methods.POST, api.NGB, data);
export const getClientDepositList = (id) =>
  serviceMaker(`/deposit/clientdepoist/${id}`, methods.GET, api.NGB);
export const deleteInvoice = (id) =>
  serviceMaker(`/billmaster/${id}`, methods.DELETE, api.NGB);
export const getBillActionList = (id) =>
  serviceMaker(
    `/collectionscenario/collectionAction?clientId=${id}`,
    methods.GET,
    api.NGB
  );
export const fetchParentClient = (clientId) =>
  serviceMaker(`/parentclient/?query=${clientId}`, methods.GET, api.NGB);
export const callCustomerApi = (data) =>
  serviceMaker(`/api/cti/outbound`, methods.POST, api.NGB_SOCKET, data);
export const fetchAllowance = (payload) =>
  serviceMaker(
    `/extrnal/getAllAllowences?customerId=${payload.customerId}&accountNumber=${payload.accountNo}&serviceNumber=${payload.serviceNumber}&serviceType=${payload.type}`,
    methods.GET,
    api.NGB,
    {
      headers: {
        "ngb-platform-tenantid": "default",
      },
    }
  );
export const updateSpendCap = (id, data) =>
  serviceMaker(`/clientservice/spendcap/${id}`, methods.PUT, api.NGB, data);
export const getSpendCap = (id) =>
  serviceMaker(`/extrnal/spendLimit/${id}/0`, methods.GET, api.NGB);
export const reactivateService = (id, data) =>
  serviceMaker(`/clientservice/reactive/${id}`, methods.PUT, api.NGB, data);
export const getPromotionFeatureList = (id) =>
  serviceMaker(`/promotion/${id}/documents/plan/${id}`, methods.GET, api.NGB);
export const getCreditLimit = (id) =>
  serviceMaker(
    `/extrnal/mobile/subscriber/${id}/creditLimit`,
    methods.GET,
    api.NGB
  );
export const checkCreditLimitStatus = (id) =>
  serviceMaker(`/makercheckers/creditLimitStatus/${id}`, methods.GET, api.NGB);
export const updateCreditLimit = (data) =>
  serviceMaker(
    `/creditlimit/credit/${data.id}`,
    methods.PUT,
    api.NGB,
    data.data
  );
export const getFeedbackQuestions = (id) =>
  serviceMaker(`/feedback/ticket/${id}`, methods.GET, api.NGB);
export const createFeedback = (payload) =>
  serviceMaker(`/feedback/submit`, methods.POST, api.NGB, payload.data);
export const getExternal = (id) =>
  serviceMaker(`/extrnal/subscriber/${id}`, methods.GET, api.NGB);
export const updateExternal = (payload) =>
  serviceMaker(
    `/extrnal/subscriber/${payload.id}`,
    methods.PUT,
    api.NGB,
    payload.data
  );
export const redeemVoucher = (payload) =>
  serviceMaker(`/redemption/V3`, methods.POST, api.NGB, payload);
export const getScheduleOrdersById = (clientId) =>
  serviceMaker(`/scheduledorders?clientId=${clientId}`, methods.GET, api.NGB);
export const getSwapSerialNumber = (search) =>
  serviceMaker(
    `/extrnal/inventory/items/swapSerialNumber?search=${search}`,
    methods.GET,
    api.NGB
  );
export const swapSim = (payload) =>
  serviceMaker(`/itemdetails/swapSim`, methods.POST, api.NGB, payload);
// https://ngbssapi.tayana.in/ngbss-provider/api/extrnal/inventory/items/swapSerialNumber?search=5018
// ngbss-provider/api/itemdetails/swapSim
//more info---child apis
export const addChildToFamilyPlan = (payload) =>
  serviceMaker(`/familyPlan/addChild`, methods.POST, api.NGB, payload);
export const removeChildFromFamilyPlan = (data) =>
  serviceMaker(`/familyPlan/removeChild`, methods.PUT, api.NGB, data);
export const getChildListByParent = (parentId) =>
  serviceMaker(`/familyPlan/childList/${parentId}`, methods.GET, api.NGB);
export const getParentDetailsByChild = (childId) =>
  serviceMaker(`/familyPlan/parentDetails/${childId}`, methods.GET, api.NGB);
export const getTopup = (data) =>
  serviceMaker(`/extrnal/topup`, methods.POST, api.NGB, data);
